"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCommonStyles = void 0;
const css_1 = require("@emotion/css");
const useCommonStyles = () => {
    return {
        inlineFieldNoMarginRight: (0, css_1.css)({
            marginRight: 0,
        }),
        // This is dirty hack to make configured secret input grow
        inlineFieldWithSecret: (0, css_1.css)({
            '[class$="layoutChildrenWrapper"]:first-child': {
                flexGrow: 1,
            },
        }),
    };
};
exports.useCommonStyles = useCommonStyles;
//# sourceMappingURL=styles.js.map